import { render, staticRenderFns } from "./PickerGroup.vue?vue&type=template&id=06fba8e1&"
import script from "./PickerGroup.vue?vue&type=script&lang=js&"
export * from "./PickerGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports